const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M27.712 15.232q0.448 0.32 0.448 0.768t-0.448 0.704l-11.904 7.936q-0.704 0.448-1.184 0.192t-0.48-1.152v-15.424q0-0.896 0.48-1.152t1.184 0.192zM13.184 15.232q0.448 0.32 0.448 0.768t-0.448 0.704l-11.52 7.936q-0.64 0.448-1.152 0.192t-0.512-1.152v-15.424q0-0.896 0.512-1.152t1.152 0.192z"
});

const SvgForward = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    id: "icon-forward",
    viewBox: "0 0 30 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgForward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/forward.976d208e.svg";
export { ForwardRef as ReactComponent };